import { P2GGrid, SvgEnquiryMoreInfo } from '@parcel2go/core-ui';
import CdnIconProxy from '~/apps/account-linking/components/CdnIconProxy';

interface props {
  color?: 'info' | 'warning' | 'error' | 'success';
  icon?: React.ReactNode;
  iconSrc?: string;
  loader?: React.ReactNode;
  iconSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  children: React.ReactNode;
}

const EasyInfo: React.FC<props> = (props) => {
  return (
    <P2GGrid container alignItems="center" wrap="nowrap" gap={2}>
      <P2GGrid item flexShrink={1}>
        <CdnIconProxy
          size={props.iconSize || 'sm'}
          palette={props.color || 'primary'}
          src={props.iconSrc || '/theme/icons/EnquiryExclamation.svg'}
        >
          {props.icon || <SvgEnquiryMoreInfo />}
        </CdnIconProxy>
      </P2GGrid>
      <P2GGrid item flexGrow={1}>
        {props.children}
      </P2GGrid>
    </P2GGrid>
  );
};

export default EasyInfo;
